/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { DomainRecruiterNewDriverInfo } from '../../entities/domain/RecruiterNewDriverInfo'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const domainRecruiterNewDriverInfoSchema = z.object({
  attacher_worker_last_error: z.string().optional(),
  company_was_recruiter: z.boolean().optional(),
  company_was_taxopark: z.boolean().optional(),
}) as unknown as ToZod<DomainRecruiterNewDriverInfo>